import type { ToastProps, ToastProviderProps, ToastViewportProps } from '@radix-ui/react-toast';
import { Provider, Root, Title, Close, Viewport } from '@radix-ui/react-toast';
import { twMerge } from 'tailwind-merge';

import CrossIcon from '../assets/icons/CrossIcon';

function SuccessIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 4.63636C16.0668 4.63636 19.3636 7.93318 19.3636 12C19.3636 16.0668 16.0668 19.3636 12 19.3636C7.93318 19.3636 4.63636 16.0668 4.63636 12C4.63636 7.93318 7.93318 4.63636 12 4.63636ZM15.6629 9.08709C15.2968 8.72097 14.7032 8.72097 14.3371 9.08709L10.875 12.5494L9.66291 11.3371L9.61391 11.2914C9.24561 10.9717 8.68729 10.9869 8.33709 11.3371C7.97097 11.7032 7.97097 12.2968 8.33709 12.6629L10.2121 14.5379L10.2611 14.5836C10.6294 14.9033 11.1877 14.8881 11.5379 14.5379L15.6629 10.4129L15.7086 10.3639C16.0283 9.99561 16.0131 9.43729 15.6629 9.08709Z"
        fill="#008059"
      />
    </svg>
  );
}

function ErrorIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM19.3636 12C19.3636 7.93318 16.0668 4.63636 12 4.63636C7.93318 4.63636 4.63636 7.93318 4.63636 12C4.63636 16.0668 7.93318 19.3636 12 19.3636C16.0668 19.3636 19.3636 16.0668 19.3636 12ZM13.876 8.96691C14.1955 8.64739 14.7136 8.64739 15.0331 8.96691C15.328 9.26185 15.3507 9.72595 15.1012 10.0469L15.0331 10.124L13.1571 12L15.0331 13.876C15.3526 14.1955 15.3526 14.7136 15.0331 15.0331C14.7381 15.328 14.274 15.3507 13.9531 15.1012L13.876 15.0331L12 13.1571L10.124 15.0331C9.80448 15.3526 9.28643 15.3526 8.96691 15.0331C8.67197 14.7381 8.64928 14.274 8.89885 13.9531L8.96691 13.876L10.8429 12L8.96691 10.124C8.64739 9.80448 8.64739 9.28643 8.96691 8.96691C9.26185 8.67197 9.72595 8.64928 10.0469 8.89885L10.124 8.96691L12 10.8429L13.876 8.96691Z"
        fill="#F41F40"
      />
    </svg>
  );
}

function WarningIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.98302 5.26036C10.4106 4.55547 11.1752 4.125 11.9996 4.125C12.824 4.125 13.5886 4.55547 14.0185 5.2641L20.6839 16.3918C21.103 17.1175 21.1055 18.0111 20.6905 18.7392C20.2755 19.4673 19.5053 19.9204 18.6587 19.9297L5.33189 19.9297C4.49389 19.9204 3.72372 19.4673 3.30872 18.7392C2.89372 18.0111 2.89622 17.1175 3.32168 16.3809L9.98302 5.26036ZM12.6718 6.07585C12.5293 5.84088 12.2744 5.69739 11.9996 5.69739C11.7248 5.69739 11.4699 5.84088 11.3297 6.07211L4.67697 17.1781C4.53728 17.42 4.53644 17.7178 4.67478 17.9605C4.81311 18.2032 5.06984 18.3543 5.34053 18.3573L18.6501 18.3574C18.9294 18.3543 19.1861 18.2032 19.3244 17.9605C19.4628 17.7178 19.4619 17.42 19.3286 17.1889L12.6718 6.07585ZM11.9996 8.92295C12.4028 8.92295 12.7351 9.22646 12.7805 9.61746L12.7858 9.70915V12.8539C12.7858 13.2881 12.4338 13.6401 11.9996 13.6401C11.5964 13.6401 11.2641 13.3366 11.2187 12.9456L11.2134 12.8539V9.70915C11.2134 9.27495 11.5654 8.92295 11.9996 8.92295ZM12.7937 15.9987C12.7937 15.5645 12.4417 15.2125 12.0075 15.2125L11.9079 15.2178C11.5169 15.2632 11.2134 15.5955 11.2134 15.9987C11.2134 16.4329 11.5654 16.7849 11.9996 16.7849L12.0992 16.7796C12.4902 16.7342 12.7937 16.4019 12.7937 15.9987Z"
        fill="#FF8C00"
      />
    </svg>
  );
}

export default function Toast({
  rootProps,
  providerProps,
  viewPortProps,
  title,
  type = 'success',
}: {
  rootProps?: ToastProps;
  providerProps?: ToastProviderProps;
  viewPortProps?: ToastViewportProps;
  title: string;
  type?: 'success' | 'error' | 'warning';
}) {
  return (
    <Provider {...providerProps}>
      <Root
        {...rootProps}
        className={twMerge(
          'bg-neutral-100 shadow-2 rounded-2xl w-[330px] p-4 fixed right-6 top-[14px] sm:top-6',
          rootProps?.className,
        )}
      >
        <div className="flex flex-row items-start gap-4">
          <div className="w-6 h-6">
            {type === 'success' && <SuccessIcon />}
            {type === 'error' && <ErrorIcon />}
            {type === 'warning' && <WarningIcon />}
          </div>

          <Title className="min-h-6 flex items-center font-body-m text-body-m text-start">{title}</Title>
          <Close className="ml-auto">
            <CrossIcon fillCls="fill-neutral-0" />
          </Close>
        </div>
      </Root>

      <Viewport
        {...viewPortProps}
        className={twMerge('fixed top-6 right-6 z-50', viewPortProps?.className)}
      />
    </Provider>
  );
}
